import React, { useState } from "react";
import { isValidPhoneNumber } from "react-phone-number-input";
import { useHistory } from "react-router-dom";
import { PhoneInput } from "./components";
import { StateContext } from "context/context";
import { auth, db, firebase } from "firebase-app/config";
import * as ROUTES from "constants/routes";
import { Box, Typography } from "@material-ui/core";
import styles from "./styles/phone-login.module.scss";
import { AppAction } from "reducers/reducer-action";
import { Button, BaseInput as Input, UserOptions } from "modules/ui";
import { Col, Form, FormInstance, Row } from "antd";

declare global {
    interface Window {
        recaptchaVerifier: firebase.auth.RecaptchaVerifier;
        confirmationResult: firebase.auth.ConfirmationResult;
    }
}

interface Props {
    home?: boolean;
    event?: boolean;
    webcamCapture?: boolean;
    onWebcamSubmit?: () => void;
    handleSubmit?: (user: any) => Promise<void>;
    form?: FormInstance;
}

const PhoneLogin = ({ home, webcamCapture, onWebcamSubmit, form, handleSubmit }: Props) => {
    const { state, dispatch } = StateContext();
    const [number, setNumber] = useState<string>("");
    const [OTP, setOTP] = useState<string>("");
    const [active, setActive] = useState<boolean>(false);

    const history = useHistory();

    auth.useDeviceLanguage();

    const generateRecaptcha = () => {
        window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier("recaptcha-container", {
            "size": "invisible",
            "callback": (response: any) => {
            }
        });
    };

    const requestOTP = async (e: any) => {
        e.preventDefault();

        try {
            if (form) {
                await form.validateFields();
            }

            setActive(true);

            if (isValidPhoneNumber(number || "")) {
                generateRecaptcha();

                let appVerifier = window.recaptchaVerifier;

                auth.signInWithPhoneNumber(number, appVerifier)
                    .then((confirmationResult) => {

                        // SMS sent. Prompt user to type the code from the message, then sign the
                        // user in with confirmationResult.confirm(code).                   
                        window.confirmationResult = confirmationResult;

                    }).catch((error) => { });
            }
        } catch (error: any) {
            console.log("Error", error);
        }
    };

    const verifyOTP = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();

        let value = e.target.value;

        setOTP(value);

        if (value.length === 6) {
            let confirmationResult = window.confirmationResult;

            confirmationResult.confirm(value).then(async (result) => {
                // User signed in successfully.
                const user = result.user;

                if (user) db.collection("users").doc(user.uid).set({});

                dispatch({
                    type: AppAction.SetPhone,
                    payload: {
                        ...state,
                        userNumber: number,
                        user: user,
                    }
                });

                if (handleSubmit) await handleSubmit(user);

                if (home) {
                    history.push(ROUTES.EVENTS);
                }

                if (webcamCapture && onWebcamSubmit && !state.event.photo.retake) {
                    onWebcamSubmit();
                }

            }).catch((error) => {

                setActive(false);
                // User couldn't sign in (bad verification code?)
                // ...
            });
        }
    };

    return (
        <Row gutter={[0, 24]}>
            <Col span={24}>
                <UserOptions form={form} />
                <form onSubmit={requestOTP} action="" className={styles.content}>
                    <PhoneInput number={number} setNumber={setNumber} />
                    <Button
                        fullWidth
                        type="submit"
                        style={{ opacity: (isValidPhoneNumber(number ?? "") && !active) ? "1" : ".5", borderRadius: 90 }}
                        disabled={!isValidPhoneNumber(number ?? "")}
                        variant="contained"
                        color="primary"
                        btnType="primary"
                    >
                        {active ? "Enter Code Below" : "Verify Phone Number (Required)"}
                    </Button>
                    <Box>
                        <Input
                            disabled={!active}
                            autoComplete="one-time-code"
                            onChange={verifyOTP}
                            size="large"
                            variant="outlined"
                            placeholder="Enter Code"
                            type="number"
                            value={OTP}
                            maxLength={6}
                        />
                    </Box>
                </form>
            </Col>
            <Col span={24}>
                <div>
                    <Typography variant="body1">Please Enter the One time pin sent to your phone</Typography>
                </div>
                <div style={{ position: "absolute", zIndex: -1 }} id="recaptcha-container"></div>
                {home && <span className="home__divider">or</span>}
            </Col>
        </Row>
    );
};

export default PhoneLogin;